export default __webpack_public_path__ + "static/media/MAX 125_4.d10b3c03.webp";